import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface IndicatorBarProps {
  color?: string
  width?: number
  borderRadius?: number
  height?: number
}

export const IndicatorBar = ({
  color,
  width = 10,
  borderRadius = 0.75,
  height,
}: IndicatorBarProps) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width,
        height: height || '100%',
        borderRadius,
        backgroundColor: color || theme.palette.red[500],
      }}
    />
  )
}
